import { type FormConfig, type SelectOption } from '@acme/foundation';

export const exchangeRateFormConfig = (
  includeUnchangedFields: boolean = true,
  currencyOptions: SelectOption[]
): FormConfig => ({
  id: 'add-currency-form',
  includeUnchangedFields, // возвращаем все поля или только измененные
  controls: [
    {
      id: 'cryptoCurrency',
      label: 'Валюта',
      type: 'select',
      read: (ctx: any) => ctx?.cryptoCurrency || '',
      write: { path: 'cryptoCurrency' },
      props: {
        placeholder: 'Выберите валюту',
      },
      options: {
        source: currencyOptions,
      },
    },
    {
      id: 'amount',
      label: 'Общий объём валюты',
      type: 'number',
      read: (ctx: any) => ctx?.amount || '',
      write: { path: 'amount' },
      props: {
        placeholder: 'Выберите объём',
      },
    },
    {
      id: 'expireAt',
      label: 'Время действия курса',
      type: 'datepicker',
      read: (ctx: any) => ctx?.expireAt || '',
      write: { path: 'expireAt' },
      props: {
        placeholder: 'Действителен до:',
      },
    },
  ],
});
